import { useInView } from "framer-motion";
import React, { useRef } from "react";

const Animation = ({ children, isHeight = true }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <section
      ref={ref}
      //   style={{ }}
      style={{
        maxHeight: isHeight && "600px",
        transform: isInView ? "none" : "translateY(-200px)",
        opacity: isInView ? 1 : 0,
        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
      }}
    >
      {children}
    </section>
  );
};

export default Animation;
